import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTheme } from 'styled-components';
import { type DeliveryAddress } from '@koala/sdk';
import { DeliverySearchStoredAddresses } from '../storedAddresses';
import GoogleAutocomplete from '@/components/fulfillmentManager/deliveryManager/deliveryForm/autocomplete';
import { locationsActions } from '@/redux/locations/actions';
import { type RootState } from '@/types/app';

interface AdditionalProps {
  apiKey?: string;
  loading?: boolean;
  searchDeliveryCoverage?: (address: DeliveryAddress) => void;
}

const noop = (address: DeliveryAddress) => {
  console.log(`No operation performed with address:`, address);
};

const BaseDeliverySearch: React.FC<AdditionalProps> = ({
  apiKey = '',
  loading = false,
  searchDeliveryCoverage,
}) => {
  return (
    <div>
      <GoogleAutocomplete
        loading={!!loading}
        apiKey={apiKey || ''}
        checkOrSearchDeliveryCoverage={searchDeliveryCoverage ?? noop}
      />
      <DeliverySearchStoredAddresses />
    </div>
  );
};

function useDeliverySearchProps() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const loading = useSelector((state: RootState) => state.app.locations.searchLoading);

  const searchDeliveryCoverage = (address: DeliveryAddress) => {
    dispatch(locationsActions.searchDeliveryCoverage(address));
  };

  return {
    loading,
    apiKey: process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY ?? theme.locations.map_key,
    searchDeliveryCoverage,
  };
}

const DeliverySearch = () => {
  const { loading, apiKey, searchDeliveryCoverage } = useDeliverySearchProps();
  return (
    <BaseDeliverySearch
      loading={loading}
      apiKey={apiKey}
      searchDeliveryCoverage={searchDeliveryCoverage}
    />
  );
};

export default DeliverySearch;
